export const DISPLAY_MODE_HOTSPOT_TYPE = "hotspot";
export const DISPLAY_MODE_SHOP_IT_TYPE = "shop_it";
export const PRODUCT_PAGE_WIDGET = "product";
export const MAIN_PAGE_WIDGET = "main";
export const INSTAGRAM_PAGE_WIDGET = "instagramPage";

export type WIDGET_TYPE =
    | typeof PRODUCT_PAGE_WIDGET
    | typeof MAIN_PAGE_WIDGET
    | typeof INSTAGRAM_PAGE_WIDGET;
